// extracted by mini-css-extract-plugin
export default {"historyButton":"historyButton_historyButton__8Di7x","disabled":"historyButton_disabled__zFoEy"};